import { render } from "./InventoryDetails.vue?vue&type=template&id=d0fb5c8c&scoped=true"
import script from "./InventoryDetails.vue?vue&type=script&lang=js"
export * from "./InventoryDetails.vue?vue&type=script&lang=js"

import "./InventoryDetails.vue?vue&type=style&index=0&id=d0fb5c8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0fb5c8c"]])

export default __exports__